import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
    selectUniversityGradeDetailByRecord({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post('/universityGrade/selectUniversityGradeDetailByRecord', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },


  getProvince({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get('/system/province/getProvinceAll').then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSubjectList({ commit }, params) {
    return new Promise((resolve, reject) => {
        axios.post('/universityGrade/getSubjectList' , params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  },

  getBatchNum({ commit }, params) {
    return new Promise((resolve, reject) => {
        axios.post('/universityGrade/getBatchNum' , params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  },

  getBatchNumX({ commit }, params) {
    return new Promise((resolve, reject) => {
        axios.post('/universityGrade/getBatchNumX' , params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  },

  getSubjectPreview({ commit }, params) {
    return new Promise((resolve, reject) => {
        axios.post('/universityGrade/getSubjectPreview' , params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  },

  insert({ commit }, params) {
    return new Promise((resolve, reject) => {
        axios.post('/universityGrade/insert' , params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  },

  updateUniversityGradeDetailInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
        axios.post('/universityGrade/updateUniversityGradeDetailInfo' , params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  },

  del({ commit }, params) {
    return new Promise((resolve, reject) => {
        axios.post('/universityGrade/del' , params).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
  },
}
